// Temporarily withhold a write by adding an entry here. A listed control is
// disabled with its reason and its API call rejects without a request.
// Remittance requires pam-deacon #360 before frontend cutover.
export const UNAVAILABLE_WRITES = Object.freeze({});

/** The unavailability text for `feature`, or null when the backend serves it. */
export const unavailableReason = (feature) => UNAVAILABLE_WRITES[feature] || null;

/**
 * A rejected write for an unavailable feature, shaped like the backend's own
 * 503 (`error`/`message`) so core's getWriteErrorMessage shows the text, and
 * marked so callers can tell nothing was sent.
 */
export const unavailableError = (feature) => {
  const message = unavailableReason(feature) || 'This action is unavailable.';
  const error = new Error(message);
  error.unavailable = true;
  error.response = { status: 503, data: { error: 'feature_unavailable', message } };
  return error;
};

/** Reject `feature`'s write locally when it is unavailable, otherwise run `send`. */
export const guardWrite = (feature, send) =>
  unavailableReason(feature) ? Promise.reject(unavailableError(feature)) : send();
